"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CopySurveyRequestModel () {
        return CopySurveyRequestModel;
    },
    get CreateSurveyArgsSchema () {
        return CreateSurveyArgsSchema;
    },
    get CreateSurveyResponseRequestModel () {
        return CreateSurveyResponseRequestModel;
    },
    get GetSurveyLinkResponseModel () {
        return GetSurveyLinkResponseModel;
    },
    get MAX_NUMBER_QUESTION_OPTIONS () {
        return MAX_NUMBER_QUESTION_OPTIONS;
    },
    get MAX_SURVEY_NAME_LENGTH () {
        return MAX_SURVEY_NAME_LENGTH;
    },
    get ReScheduleSurveyEmailRequestModel () {
        return ReScheduleSurveyEmailRequestModel;
    },
    get SURVEY_QUESTION_TYPES () {
        return SURVEY_QUESTION_TYPES;
    },
    get SURVEY_QUESTION_TYPES_LABELS () {
        return SURVEY_QUESTION_TYPES_LABELS;
    },
    get ScheduleSurveyEmailRequestModel () {
        return ScheduleSurveyEmailRequestModel;
    },
    get SearchField () {
        return SearchField;
    },
    get SurveyAvailabilityStatusSchema () {
        return SurveyAvailabilityStatusSchema;
    },
    get SurveyAvailabilityStatuses () {
        return SurveyAvailabilityStatuses;
    },
    get SurveyModel () {
        return SurveyModel;
    },
    get SurveyMultipleChoiceOptionSchema () {
        return SurveyMultipleChoiceOptionSchema;
    },
    get SurveyParticipantModel () {
        return SurveyParticipantModel;
    },
    get SurveyQuestionSchema () {
        return SurveyQuestionSchema;
    },
    get SurveyQuestionsResultsRequestModel () {
        return SurveyQuestionsResultsRequestModel;
    },
    get SurveyQuestionsResultsResponseModel () {
        return SurveyQuestionsResultsResponseModel;
    },
    get SurveyRatingScaleOptionSchema () {
        return SurveyRatingScaleOptionSchema;
    },
    get SurveyResultsOverviewResponseModel () {
        return SurveyResultsOverviewResponseModel;
    },
    get SurveyResultsRequestModel () {
        return SurveyResultsRequestModel;
    },
    get SurveySchema () {
        return SurveySchema;
    },
    get SurveyValidationSchema () {
        return SurveyValidationSchema;
    },
    get UpdateSurveyArgsModel () {
        return UpdateSurveyArgsModel;
    },
    get UpdateSurveyArgsSchema () {
        return UpdateSurveyArgsSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const MAX_SURVEY_NAME_LENGTH = 250;
const MIN_SURVEY_NAME_LENGTH = 1;
const MAX_SURVEY_DESCRIPTION_LENGTH = 500;
const MAX_SURVEY_QUESTIONS = 200;
const MAX_QUESTION_TEXT_LENGTH = 3000;
const MAX_QUESTION_SUBTITLE_LENGTH = 3000;
const MAX_NUMBER_QUESTION_OPTIONS = 20;
const SURVEY_QUESTION_TYPES = {
    Instructions: "instructions",
    RatingScale: "rating-scale",
    Text: "text",
    MultipleChoice: "multiple-choice",
    MultipleSelect: "multiple-select"
};
const SURVEY_QUESTION_TYPES_LABELS = {
    [SURVEY_QUESTION_TYPES.Instructions]: "Instructions",
    [SURVEY_QUESTION_TYPES.RatingScale]: "Rating Scale",
    [SURVEY_QUESTION_TYPES.Text]: "Long Answer",
    [SURVEY_QUESTION_TYPES.MultipleChoice]: "Multiple Choice",
    [SURVEY_QUESTION_TYPES.MultipleSelect]: "Multiple Select"
};
const QuestionTypeSchema = _zod.z.enum(Object.values(SURVEY_QUESTION_TYPES));
/**
 * Represents how the survey will be presented to the user.
 * e.g. single-page, single-question, etc.
 */ const ResponseModeSchema = _zod.z.enum([
    "single-page"
]);
const SurveyRatingScaleOptionSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    text: _zod.z.string().trim().max(MAX_QUESTION_TEXT_LENGTH).min(1, "Answer option cannot be empty"),
    description: _zod.z.string().max(MAX_QUESTION_SUBTITLE_LENGTH).optional(),
    order: _zod.z.number(),
    value: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]).nullable(),
    // preserve deleted rating scale options on published surveys, because they
    // may have already been answered and we want to include them in the results
    deleted: _zod.z.boolean().nullish()
});
const SurveyMultipleChoiceOptionSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    text: _zod.z.string().max(MAX_QUESTION_TEXT_LENGTH, `Answer option cannot be longer than ${MAX_QUESTION_TEXT_LENGTH} characters`).min(1, "Answer option cannot be empty"),
    order: _zod.z.number(),
    // preserve deleted multiple choice options on published surveys
    deleted: _zod.z.boolean().nullish()
});
const SurveyQuestionSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    type: QuestionTypeSchema,
    text: _zod.z.string().max(MAX_QUESTION_TEXT_LENGTH),
    subtitle: _zod.z.string().max(MAX_QUESTION_SUBTITLE_LENGTH).optional(),
    order: _zod.z.number(),
    question_settings: _zod.z.object({
        is_required: _zod.z.boolean()
    }).optional(),
    options: _zod.z.array(_zod.z.union([
        SurveyRatingScaleOptionSchema,
        SurveyMultipleChoiceOptionSchema
    ])).max(MAX_NUMBER_QUESTION_OPTIONS).optional().nullish(),
    deleted: _zod.z.boolean().nullish()
});
const SurveySchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    created_by: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string().trim().min(MIN_SURVEY_NAME_LENGTH).max(MAX_SURVEY_NAME_LENGTH),
    description: _zod.z.string().max(MAX_SURVEY_DESCRIPTION_LENGTH).optional(),
    created_at: _zod.z.date(),
    updated_at: _zod.z.date(),
    updated_by: _zod.z.instanceof(_bson.ObjectId),
    start_date: _zod.z.date().nullish(),
    end_date: _zod.z.date().nullish(),
    schedule_dates: _zod.z.boolean().optional(),
    status: _zod.z.enum([
        "draft",
        "active",
        "closed"
    ]),
    response_mode: ResponseModeSchema.optional(),
    survey_link: _zod.z.string().optional(),
    participant_selection: _zod.z.object({
        type: _zod.z.literal("perform_yard_users").optional(),
        enabled: _zod.z.boolean().optional().default(false),
        selection_object_id: _zod.z.instanceof(_bson.ObjectId).nullish(),
        emailed_participants: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional()
    }).optional(),
    questions: _zod.z.array(SurveyQuestionSchema).max(MAX_SURVEY_QUESTIONS),
    settings: _zod.z.object({
        is_anonymous: _zod.z.boolean().optional().default(false)
    }).optional(),
    deleted: _zod.z.object({
        deleted_at: _zod.z.date(),
        deleted_by: _zod.z.instanceof(_bson.ObjectId)
    }).optional()
});
const CreateSurveyArgsSchema = SurveySchema.omit({
    _id: true,
    company_id: true,
    created_at: true,
    updated_at: true,
    created_by: true,
    updated_by: true,
    status: true,
    survey_link: true,
    deleted: true,
    questions: true
});
const UpdateSurveyArgsSchema = SurveySchema.omit({
    _id: true,
    company_id: true,
    created_by: true,
    created_at: true,
    updated_at: true,
    updated_by: true,
    deleted: true,
    survey_link: true,
    start_date: true,
    end_date: true
}).extend({
    start_date: _zod.z.union([
        _zod.z.string().date(),
        _zod.z.date()
    ]).nullish(),
    end_date: _zod.z.union([
        _zod.z.string().date(),
        _zod.z.date()
    ]).nullish()
});
const SurveyValidationSchema = SurveySchema.omit({
    _id: true
}).merge(_zod.z.object({
    // _id optional in validations because it is not present in the
    // create survey request, but is present in the update survey request
    _id: _zod.z.instanceof(_bson.ObjectId).optional()
})).refine(({ start_date, end_date })=>{
    if (end_date && start_date && start_date > end_date) {
        return false;
    }
    return true;
}, {
    message: "Survey end date must be after start date"
});
const SurveyQuestionRatingScaleOptionModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    text: SurveyRatingScaleOptionSchema.shape.text,
    description: SurveyRatingScaleOptionSchema.shape.description,
    order: SurveyRatingScaleOptionSchema.shape.order,
    value: SurveyRatingScaleOptionSchema.shape.value,
    deleted: SurveyRatingScaleOptionSchema.shape.deleted
});
const SurveyQuestionMultipleChoiceOptionModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    text: SurveyMultipleChoiceOptionSchema.shape.text,
    order: SurveyMultipleChoiceOptionSchema.shape.order,
    deleted: SurveyMultipleChoiceOptionSchema.shape.deleted
});
const SurveyQuestionOptionsModel = _zod.z.union([
    _zod.z.array(SurveyQuestionRatingScaleOptionModel).max(MAX_NUMBER_QUESTION_OPTIONS),
    _zod.z.array(SurveyQuestionMultipleChoiceOptionModel).max(MAX_NUMBER_QUESTION_OPTIONS)
]).optional().nullish();
const SurveyQuestionModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    type: SurveyQuestionSchema.shape.type,
    text: SurveyQuestionSchema.shape.text,
    subtitle: SurveyQuestionSchema.shape.subtitle,
    order: SurveyQuestionSchema.shape.order,
    questionSettings: SurveyQuestionSchema.shape.question_settings,
    options: SurveyQuestionOptionsModel,
    deleted: SurveyQuestionSchema.shape.deleted
});
const SurveyModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    name: SurveySchema.shape.name,
    description: SurveySchema.shape.description,
    status: _zod.z.union([
        SurveySchema.shape.status,
        _zod.z.enum([
            "scheduled"
        ])
    ]),
    responseMode: SurveySchema.shape.response_mode,
    participantSelection: _zod.z.object({
        type: _zod.z.literal("perform_yard_users").optional(),
        enabled: _zod.z.boolean().optional(),
        selectionObjectId: _zod.z.union([
            _utilsisomorphic.transformObjectId,
            _zod.z.null()
        ]).optional(),
        emailedParticipants: _zod.z.array(_utilsisomorphic.transformObjectId).optional()
    }).optional(),
    startDate: _zod.z.union([
        _zod.z.date(),
        _utilsisomorphic.transformNullishDate
    ]),
    endDate: _zod.z.union([
        _zod.z.date(),
        _utilsisomorphic.transformNullishDate
    ]),
    scheduleDates: SurveySchema.shape.schedule_dates,
    surveyLink: SurveySchema.shape.survey_link,
    createdBy: _utilsisomorphic.transformObjectId,
    updatedBy: _utilsisomorphic.transformObjectId,
    createdAt: _utilsisomorphic.transformDate,
    updatedAt: _utilsisomorphic.transformDate,
    questions: _zod.z.array(SurveyQuestionModel)
});
const SurveyParticipantSelectionModel = _zod.z.object({
    type: _zod.z.literal("perform_yard_users").optional(),
    enabled: _zod.z.boolean().optional(),
    selection_object_id: _zod.z.union([
        _utilsisomorphic.transformObjectId,
        _zod.z.null()
    ]).optional(),
    emailed_participants: _zod.z.array(_utilsisomorphic.transformObjectId).optional()
});
const UpdateSurveyArgsModel = _zod.z.object({
    name: SurveySchema.shape.name.optional(),
    description: SurveySchema.shape.description.optional(),
    status: SurveySchema.shape.status.optional(),
    responseMode: SurveySchema.shape.response_mode.optional(),
    participantSelection: SurveyParticipantSelectionModel.optional(),
    startDate: _zod.z.string().nullish(),
    endDate: _zod.z.string().nullish(),
    scheduleDates: _zod.z.boolean().optional(),
    questions: _zod.z.array(SurveyQuestionModel).optional()
});
const ReScheduleSurveyEmailRequestModel = _zod.z.object({
    surveyId: _zod.z.string().nullish()
});
const ScheduleSurveyEmailRequestModel = _zod.z.object({
    surveyId: _zod.z.string().nullish(),
    urlPrefix: _zod.z.string().nullish()
});
const SearchField = _zod.z.object({
    field: _zod.z.string(),
    operator: _zod.z.enum([
        "eq",
        "re"
    ]),
    value: _zod.z.string()
});
const SurveyResultsRequestModel = _zod.z.object({
    search: SearchField.optional(),
    sorts: _utilsisomorphic.sortStringSchema.optional()
});
const SurveyQuestionsResultsRequestModel = _zod.z.object({
    search: SearchField.optional(),
    sorts: _zod.z.record(_zod.z.string(), _zod.z.number()).optional()
});
const SurveyAvailabilityStatusSchema = _zod.z.enum([
    "draft",
    "active",
    "scheduled",
    "closed",
    "completed",
    "unavailable"
]);
const GetSurveyLinkResponseModel = _zod.z.object({
    survey: SurveyModel.nullable(),
    surveyLink: _zod.z.string(),
    startDate: _zod.z.union([
        _zod.z.date(),
        _utilsisomorphic.transformNullishDate,
        _zod.z.null()
    ]).optional(),
    surveyAvailabilityStatus: SurveyAvailabilityStatusSchema
});
const CreateSurveyResponseRequestModel = _zod.z.object({
    answers: _zod.z.record(_zod.z.string(), _zod.z.union([
        _zod.z.string(),
        _zod.z.array(_zod.z.string())
    ]))
});
const CopySurveyRequestModel = _zod.z.object({
    name: _zod.z.string().min(MIN_SURVEY_NAME_LENGTH).max(MAX_SURVEY_NAME_LENGTH),
    surveyId: _utilsisomorphic.transformObjectId
});
const SurveyResultsOverviewResponseModel = _zod.z.object({
    averagePercentageOfQuestionsAnswered: _zod.z.number(),
    totalResponses: _zod.z.number()
});
const SurveyQuestionsResultsResponseModel = _zod.z.object({
    questions: _zod.z.array(_zod.z.object({
        question_text: _zod.z.string(),
        question_type: _zod.z.enum(Object.values(SURVEY_QUESTION_TYPES_LABELS)).refine((value)=>value !== SURVEY_QUESTION_TYPES_LABELS[SURVEY_QUESTION_TYPES.Instructions]),
        response_count: _zod.z.number(),
        options_results: _zod.z.array(_zod.z.object({
            option_text: _zod.z.string(),
            option_value: _zod.z.union([
                _zod.z.number(),
                _zod.z.string()
            ]).nullish(),
            response_count: _zod.z.number()
        })).optional()
    }))
});
const SurveyParticipantModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    email: _zod.z.string(),
    name: _zod.z.string()
});
const SurveyAvailabilityStatuses = Object.values(SurveyAvailabilityStatusSchema.enum).reduce((acc, status)=>{
    const upperCaseStatus = status.toUpperCase();
    acc[upperCaseStatus] = status;
    return acc;
}, {});
